import NextCloudEmbed from './NextCloudEmbed';

const players = {
  nextCloud: NextCloudEmbed,
};

export default players;
